import script from "./base-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-input.vue?vue&type=script&setup=true&lang=ts"

import "./base-input.vue?vue&type=style&index=0&id=4592cc33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4592cc33"]])

export default __exports__